import { jsx, jsxs } from "react/jsx-runtime";
import CloseSmall from "@crehana/compass.icons.outline/CloseSmall";
import { clsx } from "clsx";
import { TOAST_COLORS } from "../constants.js";
import { ToastIcon } from "./ToastIcon.js";
import { ToastInformation } from "./ToastInformation.js";
const ToastContent = ({ title, subtitle, textLink, type = 'informative', onClose })=>/*#__PURE__*/ jsxs("div", {
        className: "tw-w-[32.8rem] sm:tw-w-[38rem] tw-flex tw-items-start",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: clsx('tw-rounded-l-1 tw-h-full tw-w-0.4 tw-flex-shrink-0', TOAST_COLORS[type].leftBorder.light, TOAST_COLORS[type].leftBorder.dark)
            }),
            /*#__PURE__*/ jsxs("div", {
                className: clsx('dark:tw-bg-elevation-dark-03 tw-bg-neutral-light-100 tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-[0.1rem] dark:tw-border-l-0 tw-border-solid tw-py-1.2 tw-px-1.6 tw-flex', TOAST_COLORS[type].otherBordersDark),
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: "tw-w-2 tw-mr-0.8",
                        children: /*#__PURE__*/ jsx(ToastIcon, {
                            type: type
                        })
                    }),
                    /*#__PURE__*/ jsx(ToastInformation, {
                        title: title,
                        subtitle: subtitle,
                        textLink: textLink,
                        type: type
                    }),
                    /*#__PURE__*/ jsx("button", {
                        type: "button",
                        onClick: onClose,
                        className: "tw-ml-1.2 tw-h-2",
                        children: /*#__PURE__*/ jsx(CloseSmall, {
                            className: "tw-text-neutral-light-700 ",
                            size: 20
                        })
                    })
                ]
            })
        ]
    });
export { ToastContent };
